import Head from 'next/head';
import { NextSeo } from 'next-seo';
import {SubCategory} from "@/types";
import {BUSINESS_NAME, businessDetails, contactDetails, defaultMetaTags, googleDetails, WEBSITE_URL} from "@/content";

export default function ServiceSEO({service} : { service: SubCategory }) {
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": service.title,
        "description": service.description,
        "serviceType": service.metaTags?.title,
        "url": service.metaTags?.url,
        "provider": {
            "@type": "LocalBusiness",
            "name": BUSINESS_NAME,
            "image": businessDetails.branding.headerLogoUrl,
            "url": WEBSITE_URL,
            "telephone": contactDetails.contactNumberOne,
        },
        "areaServed": {
            "@type": "GeoCircle",
            "geoMidpoint": {
                "@type": "GeoCoordinates",
                "latitude": googleDetails.serviceAreaLatLong.latitude,
                "longitude": googleDetails.serviceAreaLatLong.longitude
            },
            "geoRadius": 40000
        },
        // "termsOfService": "https://zynx.com.au/terms"
    };

    return (
        <>
            <NextSeo
                title={service.metaTags?.title || service.title}
                description={service.metaTags?.description || service.description}
                openGraph={{
                    url: service.metaTags?.url || WEBSITE_URL,
                    title: service.metaTags?.title || service.title,
                    description: service.metaTags?.description || service.description,
                    images: [
                        {
                            url: service.metaTags?.ogImage || defaultMetaTags.ogImage, //ideally under 300kb
                            width: 1200,
                            height: 630,
                            alt: service.title,
                        },
                    ],
                }}
            />

            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
                />
            </Head>
        </>
    );
}
